<template>
  <div class="login_wrap">
    <div class="login_content" v-show="isTrue">
      <div class="reset_success">
        <div><img src="../../../assets/img/success.png" style="width:86px;height:86px;" alt="" /></div>
        <div class="success_text">密码重置成功！</div>
        <div><el-button type="primary" round style="width:120px;" @click="toLogin"> 去登陆</el-button></div>
      </div>
    </div>
    <div class="login_content" v-show="!isTrue">
      <div class="login_title">重置密码</div>
      <div class="login_tips">【新密码规则】 必须是由大写字母，小写字母，数字，以及特殊字符@_.\-#$%!组成，且长度不少于8位；</div>
      <div class="login_form">
        <el-form :model="ruleForm" :rules="rules" status-icon ref="ruleForm" size="medium" class="demo-ruleForm"
          label-position="top">
          <div class="ruleForm-div">
            <el-form-item label="手机号" prop="iphone">
              <el-input v-model="ruleForm.iphone" autocomplete="off" style="width:60%;"></el-input>
            </el-form-item>
            <el-form-item label="验证码" prop="code">
              <el-input v-model="ruleForm.code" autocomplete="off" style="width:140px;"></el-input>
              <el-button v-if="sendMsgDisabled" type="primary" round :disabled="disabledBtn"
                @click.stop="getPhoneCode">获取验证码</el-button>
              <el-button v-if="!sendMsgDisabled" type="primary" round disabled>{{ count + ' 秒后重新获取' }}</el-button>
            </el-form-item>

            <el-form-item class="bottom_form">
              <el-button type="primary" round style="width:60%;" :disabled="disabledBtn" @click="nextConfirm"> 下一步
              </el-button>
            </el-form-item>
          </div>
          <div class="ruleForm-div">
            <el-form-item label="新密码" prop="pass">
              <el-input :type="passwordType" v-model="ruleForm.pass" autocomplete="off" style="width:60%;"
                :disabled="disabledBtn2">
                <i slot="suffix" v-if="passwordType !== 'password'" class="el-input__icon iconfont iconzhengyan"
                  style="cursor: pointer; font-size: 20px;color:#2D99D7;" @click="showPwd"></i>
                <i slot="suffix" v-if="passwordType === 'password'" class="el-input__icon iconfont iconbiyan1"
                  style="cursor: pointer; font-size: 20px;" @click="showPwd"></i>
              </el-input>
            </el-form-item>
            <el-form-item label="确认新密码" prop="checkPass">
              <el-input :type="checkPasswordType" v-model="ruleForm.checkPass" style="width:60%;"
                :disabled="disabledBtn2">
                <i slot="suffix" v-if="checkPasswordType !== 'password'" class="el-input__icon iconfont iconzhengyan"
                  style="cursor: pointer; font-size: 20px;color:#2D99D7;" @click="showPwdCheck"></i>
                <i slot="suffix" v-if="checkPasswordType === 'password'" class="el-input__icon iconfont iconbiyan1"
                  style="cursor: pointer; font-size: 20px;" @click="showPwdCheck"></i>
              </el-input>
            </el-form-item>
            <el-form-item class="bottom_form">
              <el-button type="primary" round style="width:60%;" :disabled="disabledBtn2" @click="submitForm('ruleForm')">
                确认</el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="login_tips2 ">
        [当前账号信息]：{{ routerPrams.sysuser ? routerPrams.sysuser : "暂未选择" }}-{{ routerPrams.calName ? routerPrams.calName : "" }}-{{ routerPrams.calCode ? routerPrams.calCode : "" }}
      </div>
    </div>
    <el-dialog width="40%" :visible.sync="dialogVisible">
      <template slot="title">
        <div class="patient_dialogheader">
          <div class="dialog_title">检测到你账号 <span style="color:red;">【{{ ruleForm.iphone ? ruleForm.iphone : "" }}】</span>
            下关联多家账户，请选择你本次需要修改的账户；</div>
        </div>
      </template>
      <div class="dialogTable" style="height: calc(100vh - 380px)">
        <el-table :data="accountData" border :header-cell-style="{ backgroundColor: '#F3F4F7' }" height="100%"
          style="width: 100%" highlight-current-row>
          <el-table-column type="index" width="50" align="center"></el-table-column>
          <el-table-column prop="calCode" width="100" label="编码" align="center"></el-table-column>
          <el-table-column prop="calName" label="名称" align="center"></el-table-column>
          <el-table-column prop="sysusername" width="100" label="负责人" align="center"></el-table-column>
          <el-table-column prop="operatoridentity" width="100" label="角色" align="center">
            <template slot-scope="scope">
              <el-tag type="success" v-if="scope.row.operatoridentity == 'admin'">管理员</el-tag>
              <el-tag type="warning" v-else-if="scope.row.operatoridentity == 'D'">医生</el-tag>
              <el-tag type="info" v-else-if="scope.row.operatoridentity == 'D'">其他</el-tag>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="cml_mobile_phone" label="电话" align="center"></el-table-column> -->
          <el-table-column label="操作" align="center" fixed="right" width="100">
            <template slot-scope="scope">
              <span style="font-size: 13px; color: #36b6ff; cursor: pointer" @click.stop="clickRow(scope.row)">
                选择
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request';
export default {
  data() {
    var checkphone = (rule, value, callback) => {
      if (value == '') {
        callback(new Error('请输入手机号'));
      } else if (!this.isCellPhone(value)) {
        //引入methods中封装的检查手机格式的方法
        callback(new Error('输入手机号格式错误!'));
      } else {
        callback();
      }
    };
    var checknewpass = (rule, value, callback) => {
      if (value == '') {
        callback(new Error('请输入新密码'));
      } else if (!this.checkedPassWordDreg(value)) {
        //引入methods中封装的检查手机格式的方法
        callback(new Error('新密码不符合规则，请重新根据规则输入;'));
      } else {
        callback();
      }
    };
    var checknewpass2 = (rule, value, callback) => {
      if (value == '') {
        callback(new Error('请再次输入新密码'));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error('两次新密码输入不一致，请重新检查后输入;'));
      } else if (!this.checkedPassWordDreg(value)) {
        //引入methods中封装的检查手机格式的方法
        callback(new Error('新密码不符合规则，请重新根据规则输入;'));
      } else {
        callback();
      }
    };
    return {
      isTrue: false,
      checked: false,
      timer: null,
      count: null,
      disabledBtn: true,
      disabledBtn2: true,
      sendMsgDisabled: true,
      checkPasswordType: 'password',
      passwordType: 'password',
      dialogVisible: false,
      accountData: [],
      routerPrams: {},
      ruleForm: {
        iphone: '',
        code: '',
        pass: '',
        checkPass: '',
        passKey:''
      },
      rules: {
        iphone: [{ required: true, validator: checkphone, trigger: 'blur' }],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        pass: [{ required: true, validator: checknewpass, trigger: 'blur' }],
        checkPass: [{ required: true, validator: checknewpass2, trigger: 'blur' }]
      }
    };
  },
  watch: {
    'ruleForm.iphone': {
      handler: function (newV, oldV) {
        const that = this
        if (/^1(3|4|5|6|7|8|9)\d{9}$/.test(newV)) {
          that.disabledBtn = false
        } else {
          that.disabledBtn = true
        }
      },
    }
  },
  methods: {
    clickRow(row) {
      this.dialogVisible = false;
      this.routerPrams = row;
      this.disabledBtn2 = false;
    },
    // 下一步
    nextConfirm() {
      const that = this;
      if (!this.ruleForm.iphone) {
        this.$message({
          message: '请输入手机号;',
          type: 'warning'
        });
        return
      }
      if (!this.ruleForm.code) {
        this.$message({
          message: '请输入验证码;',
          type: 'warning'
        });
        return
      }
      let params = {
        phone: that.ruleForm.iphone,
        verifyCode: that.ruleForm.code,
      };
      request
        .post('/login/checkCodeAndAccountList', params, { category: 'WuFan' })
        .then((res) => {
          if (res.success) {        
            that.ruleForm.passKey =  res.data.key;         
            if(res.data.channelVoList.length===1){
               this.routerPrams = res.data.channelVoList[0];
               this.disabledBtn2 = false;
            }else if(res.data.channelVoList.length >1){
              that.dialogVisible = true;
              that.accountData = res.data.channelVoList;
            }else{
              this.$notify({
              title: '错误提示',
              type: 'warning',
              duration:0,
              message: "抱歉，该账号下未查询到关联诊所账户，暂未无法进行密码修改功能，请联系管理员;",
            });
            }
          } else {
            this.$notify({
              title: '错误提示',
              type: 'warning',
              message: res.errMsg,
            });
          }
        })
    },
    getPhoneCode() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.sendMsgDisabled = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.sendMsgDisabled = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000)
      }
      this.sendVerifyCode();//发送验证码
    },
    // 发送验证码
    sendVerifyCode() {
      const that = this;
      let params = {
        phone: that.ruleForm.iphone,
      };
      request
        .post('/login/sendSmsByforgetPassword', params, { category: 'WuFan' })
        .then((res) => {
          if (res.success) {
            this.$message({
              message: '短信发送成功;',
              type: 'success'
            });
          } else {
            this.$notify({
              title: '错误提示',             
              type: 'warning',
              message: res.errMsg,
            });
          }
        })
    },
    // 校验新密码
    checkedPassWordDreg(value) {
      const passwordreg = /^(?=.{8})(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)(?=.*?[_.\-#$%!@]).*$/;
      const isValid = passwordreg.test(value);
      if (isValid !== true) {
        return false
      } else {
        return true
      }
    },
    //检查手机号
    isCellPhone(val) {
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(val)) {
        return false;
      } else {
        return true;
      }
    },
    showPwdCheck() {
      if (this.checkPasswordType === 'password') {
        this.checkPasswordType = '';
      } else {
        this.checkPasswordType = 'password';
      }
    },
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = '';
      } else {
        this.passwordType = 'password';
      }
    },
    toLogin() {
      this.$router.push('/login');
    },
    submitForm() {
      const that = this;
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let params = {
            phone: that.ruleForm.iphone,
            key: that.ruleForm.passKey,
            newPassword: that.ruleForm.pass,
            newPassword1: that.ruleForm.checkPass,
            calCode: that.routerPrams.calCode,
            operatoridentity: that.routerPrams.operatoridentity,
          };
          request
            .post('/login/forgetPassword', params, { category: 'WuFan' })
            .then((res) => {
              if (res.success) {
                this.$message.success('密码重置成功');
                this.isTrue = true;
              } else {
                this.$notify({
                  title: '错误提示',                
                  type: 'warning',
                  message: res.errMsg,
                });
              }
            })
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.demo-ruleForm {
  width: 100%;
  // border: 1px solid red;
  display: flex;
  justify-content: space-between;

  .ruleForm-div {
    width: 50%;
    // border: 1px solid red;
    // display: flex;
    margin-left: 20px;
  }
}

.login_wrap {
  position: relative;
  background: #f1faff;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  // border: 1px solid red;
  display: flex;
  justify-content: center;
  align-items: center;

  .login_content {
    width: 850px;
    height: 500px;
    background: #ffffff;
    box-shadow: 0px 5px 50px 0px rgba(186, 186, 186, 0.5);
    border-radius: 35px;
    padding: 30px 30px;
    position: relative;

    .reset_success {
      width: 120px;
      height: 200px;
      margin: 100px auto;
      display: flex;
      justify-content: center;
      flex-wrap: wrap;

      .success_text {
        width: 100%;
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 600;
        color: #333333;
        text-align: center;
      }
    }

    .login_title {
      width: 100%;
      font-size: 20px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #2d99d7;
      text-align: center;
      border-bottom: 1px solid #f0f0f0;
      padding-bottom: 30px;
    }

    .login_tips {
      font-size: 14px;
      color: red;
      text-align: center;
      margin-top: 5px;
    }

    .login_tips2 {
      font-size: 14px;
      color: rgb(187, 183, 183);
      text-align: center;
      margin-top: 5px;
      position: absolute;
      bottom: 0;
    }

    .login_form {
      width: 100%;
      height: 320px;
      box-sizing: border-box;
      // border: 1px solid red;
      margin-top: 30px;
      // margin-left: 180px;

      ::v-deep .el-input--medium .el-input__inner {
        height: 45px !important;
        line-height: 45px !important;
        // border-radius: 0 10px 10px 0;
      }

      ::v-deep .el-button--medium {
        height: 45px !important;
        margin-left: 10px;
      }
    }
  }
}</style>
